import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const createDamage = async (values, callback) => {
    const res = await axios.post(`/damage/createdamage`, values);

    callback(res.data.response);
}

export const updateDamage = async (id, values, callback) => {
    const res = await axios.put(`/damage/updatedamage/${id}`, values);

    callback(res.data.response);
}

export const getAllDamage = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/damage/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);

    callback(res.data.response);
}

export const getDamageById = async (id, callback) => {
    await axios.get(`/damage/${id}`).then(res => {
        callback(res.data.response);
    })
}

export const DamageAPI = () => {
    const [damages, setDamages] = useState([]);
    const [damageDetail, setDamageDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [damageId, setDamageId] = useState(0);

    useEffect(() => {
        getAllDamage(rowPerPage, pageNumber, search, res => {
            setDamages(res.data);
            setTotalPages(res.totalPages || 1);
        })

        getDamageById(damageId, res => {
            setDamageDetail(res.data)
        })
    }, [callback, rowPerPage, search, pageNumber, damageId])

    return {
        damages: [damages, setDamages],
        damageDetail: [damageDetail, setDamageDetail],
        damageId: [damageId, setDamageId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback]
    }
}